(function () {
  'use strict';
  var d = document, root = d.documentElement;
  root.classList.add('s3-js');

  function $(s, c) { return (c || d).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || d).querySelectorAll(s)); }

  /* ---------- nav: hairline on scroll ---------- */
  var nav = $('.s3-nav');
  if (nav) {
    var onScroll = function () { nav.classList.toggle('is-scrolled', window.scrollY > 4); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* ---------- mobile drawer ---------- */
  var burger = $('.s3-burger'), drawer = $('#s3-drawer');
  function setDrawer(open) {
    if (!burger || !drawer) return;
    burger.setAttribute('aria-expanded', open ? 'true' : 'false');
    burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
    drawer.classList.toggle('is-open', open);
    drawer.toggleAttribute('inert', !open);
    root.classList.toggle('s3-lock', open);
  }
  if (burger && drawer) {
    drawer.setAttribute('inert', '');
    burger.addEventListener('click', function () { setDrawer(burger.getAttribute('aria-expanded') !== 'true'); });
    d.addEventListener('keydown', function (e) { if (e.key === 'Escape') setDrawer(false); });
    window.addEventListener('resize', function () { if (window.innerWidth >= 990) setDrawer(false); });
  }

  /* ---------- reveal on scroll ---------- */
  var reveals = $$('.s3-reveal');
  if ('IntersectionObserver' in window && reveals.length) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    reveals.forEach(function (el) { io.observe(el); });
  } else {
    reveals.forEach(function (el) { el.classList.add('is-in'); });
  }

  /* ---------- quantity steppers ---------- */
  d.addEventListener('click', function (e) {
    var b = e.target.closest('[data-qty]');
    if (!b) return;
    var input = b.parentElement.querySelector('input');
    if (!input) return;
    var min = parseInt(input.min || '0', 10), v = parseInt(input.value || '1', 10) + parseInt(b.dataset.qty, 10);
    input.value = Math.max(min, v);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });
  $$('form[data-cart]').forEach(function (form) {
    var t;
    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[name="updates[]"]')) return;
      clearTimeout(t);
      t = setTimeout(function () { form.submit(); }, 350);
    });
  });

  /* ---------- collection sort ---------- */
  $$('[data-sort]').forEach(function (sel) {
    sel.addEventListener('change', function () {
      var u = new URL(window.location.href);
      u.searchParams.set('sort_by', sel.value);
      u.searchParams.delete('page');
      window.location.href = u.toString();
    });
  });

  /* ---------- contact topic from ?topic= ---------- */
  var topic = new URLSearchParams(window.location.search).get('topic');
  var topicSel = $('[data-topic]');
  if (topic && topicSel) {
    $$('option', topicSel).forEach(function (o) { if (o.dataset.key === topic) topicSel.value = o.value; });
  }

  /* ---------- product gallery ---------- */
  $$('[data-gallery]').forEach(function (g) {
    var main = $('.s3-gallery__main', g), thumbs = $$('.s3-gallery__thumbs button', g), dots = $$('.s3-gallery__dots i', g);
    if (!main) return;
    function mark(i) {
      thumbs.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
      dots.forEach(function (t, k) { t.classList.toggle('is-active', k === i); });
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' }); mark(i); });
    });
    var raf;
    main.addEventListener('scroll', function () {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(function () { mark(Math.round(main.scrollLeft / Math.max(1, main.clientWidth))); });
    }, { passive: true });
    g.s3goTo = function (mediaId) {
      var slide = $('[data-media-id="' + mediaId + '"]', main);
      if (!slide) return;
      var i = $$('.s3-gallery__slide', main).indexOf(slide);
      main.scrollTo({ left: main.clientWidth * i, behavior: 'smooth' });
      mark(i);
    };
  });

  /* ---------- product options -> variant ---------- */
  $$('[data-product]').forEach(function (wrap) {
    var dataEl = $('script[data-variants]', wrap);
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent), money = wrap.dataset.moneyFormat || '{{amount}}';
    var idInput = $('input[name="id"]', wrap), btn = $('[data-add]', wrap), price = $('[data-price]', wrap);
    var bar = $('.s3-buybar'), barPrice = bar && $('[data-bar-price]', bar), barBtn = bar && $('[data-bar-add]', bar);
    var gallery = d.querySelector('[data-gallery]');

    function fmt(cents) {
      var n = (cents / 100).toFixed(2), parts = n.split('.'), int = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      var noDec = int, withDec = int + '.' + parts[1];
      return money.replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDec).replace(/\{\{\s*amount\s*\}\}/, parts[1] === '00' ? noDec : withDec)
        .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDec.replace('.', ','));
    }
    function selected() {
      return $$('fieldset[data-opt]', wrap).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
    }
    function update() {
      var sel = selected();
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      $$('fieldset[data-opt]', wrap).forEach(function (fs, i) {
        var lab = $('legend span', fs); if (lab) lab.textContent = sel[i] || '';
        $$('input', fs).forEach(function (inp) {
          var test = sel.slice(); test[i] = inp.value;
          var ok = variants.some(function (x) { return x.available && x.options.every(function (o, k) { return o === test[k]; }); });
          inp.nextElementSibling.classList.toggle('is-na', !ok);
        });
      });
      if (!v) {
        if (btn) { btn.disabled = true; btn.textContent = 'Unavailable'; }
        return;
      }
      idInput.value = v.id;
      var html = '';
      if (v.compare_at_price > v.price) html += '<s>' + fmt(v.compare_at_price) + '</s>';
      html += '<span>' + fmt(v.price) + '</span>';
      if (v.compare_at_price > v.price) html += '<span class="s3-buy__save">Save ' + fmt(v.compare_at_price - v.price) + '</span>';
      if (price) price.innerHTML = html;
      if (barPrice) barPrice.textContent = fmt(v.price);
      if (btn) { btn.disabled = !v.available; btn.textContent = v.available ? btn.dataset.label : 'Sold out'; }
      if (barBtn) { barBtn.disabled = !v.available; barBtn.textContent = v.available ? barBtn.dataset.label : 'Sold out'; }
      if (v.featured_media && gallery && gallery.s3goTo) gallery.s3goTo(v.featured_media);
      var u = new URL(window.location.href); u.searchParams.set('variant', v.id);
      window.history.replaceState({}, '', u.toString());
    }
    $$('fieldset[data-opt] input', wrap).forEach(function (inp) { inp.addEventListener('change', update); });
    if (variants.length > 1) update();

    if (bar) {
      d.body.classList.add('s3-has-buybar');
      var target = btn || wrap, ticking = false;
      var check = function () {
        ticking = false;
        var r = target.getBoundingClientRect();
        var on = r.bottom < 0 && window.innerWidth < 990;
        bar.classList.toggle('is-on', on);
        bar.setAttribute('aria-hidden', on ? 'false' : 'true');
      };
      window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(check); } }, { passive: true });
      window.addEventListener('resize', check);
      check();
      if (barBtn) barBtn.addEventListener('click', function () { if (btn && !btn.disabled) btn.click(); });
    }
  });
})();
